export { default } from './ForecastGraphAdvancedSwell';
